exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-element-overlay .mt-overlay img {\r\n    height: 150px;\r\n    width: auto;\r\n    display: inline-block;\r\n}\r\n\r\n.mt-overlay {\r\n    height: 150px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/person/details/general/general-information.component.css
// module id = 990
// module chunks = 1